<template>
  <div id="mainWrapper" class="main-wrapper main-wrapper-1">
    <template v-if="isInit">
      <Message />
      <!-- <Message />
    <LinkHandling/>
    <Navbar></Navbar>
      <Sidebar :stisla="stisla"></Sidebar>-->
      <router-view></router-view>
    </template>
  </div>
</template>
<script>
// @ is an alias to /src
//import HelloWorld from "@/components/HelloWorld.vue";
import Message from "@/components/Message.vue";
import LinkHandling from "@/components/LinkHandling.vue";

import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import MyFooter from "@/components/MyFooter.vue";
//import Dashboard from "@/views/contents/Dashboard.vue";
import Stisla from "@/assets/js/stisla";
import { mapGetters, mapActions } from 'vuex';

import helper from "@/vueHelper"

export default {
  name: "mobileapp",
  access_code: "HOME_05",
  components: {
    Navbar,
    Sidebar,
    MyFooter,
    //Dashboard,
    Message,
    LinkHandling
  },
  data() {
    return {
      stisla: null,
      isInit: false,
      sessionErrorMsg: null
    };
  },
  methods: {
    async load() {

      this.isInit = true;
      let stisla = new Stisla();
      stisla.init();
      this.stisla = stisla;
    }
  },
  mounted() {
    this.load();
  }
};
</script>

<style>
.navbar-bg {
  color: #4585ce !important;
}

.section .section-title:before {
  background-color: #4585ce !important;
}
.section-title {
  color: #4585ce !important;
}

.card-stats-item-count {
  color: #4585ce;
  cursor: pointer;
}
</style>

<style scoped>
.main-content {
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 0px;
  width: 100%;
  position: relative;
}
</style>

<!--<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data: () => ({
    h:""
  }),
  created: function(){
    this.actionResetGrid();
    this.actionSetGrid("aa01");
    this.actionSetGrid("aa02");
  },
  computed: {
    ...mapGetters("grid", ["getGrid"]),

    mySetChangeTracker(){
      this.h = this.getGrid.mySetChangeTracker;
      return this.getGrid.mySetChangeTracker;
    }

  },

  watch:{


  },

  methods: {
    ...mapActions("grid", [
      "actionResetGrid",
      "actionSetGrid",
      "actionTogglePage"
    ])
  }
};
</script>-->
<!-- <div id="app">
    <div>
      <div v-for="(data,index) in getGrid.data['aa01']" :key="index">{{data}}</div>
    </div>
    <br />
    <div>
      <div v-for="(data,index) in getGrid.data['aa02']" :key="index">{{data}}</div>
    </div>
    <button @click="actionTogglePage('aa01')">aa01 next page</button>
    <br />
    <button @click="actionTogglePage('aa02')">aa02 next page</button>
  </div> -->